var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSelectCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#select-circle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.743 8.284a1 1 0 0 1 .924-.618h6.666a1 1 0 0 1 .707 1.708l-3.333 3.333a1 1 0 0 1-1.414 0L5.959 9.374a1 1 0 0 1-.216-1.09"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 .667a9.333 9.333 0 1 0 0 18.666A9.333 9.333 0 0 0 10 .667M2.667 10a7.333 7.333 0 1 1 14.666 0 7.333 7.333 0 0 1-14.666 0",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "select-circle_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})))));
SvgSelectCircle.displayName = "SvgSelectCircle";
export { SvgSelectCircle as ReactComponent };
export default SvgSelectCircle;